export default function filterData(text, compareText) {
  return text?.toLowerCase().includes(compareText.toLowerCase());
}
